import { makeAutoObservable } from 'mobx';
import fetchService from '../servises/fetch.service';
import { registerAccountStateReset } from '../servises/account-state.service';

export class TagsStore {
    constructor() {
        makeAutoObservable(this);
    }

    tags = [];
    requestSequence = 0;

    async getTags() {
        if (this.tags.length > 0) {
            return;
        }
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedGet(
            `/tags`);

        if (requestSequence === this.requestSequence) {
            this.applyResponse(response);
        }
    }

    async createTag(data) {
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedPost(
            `/tags`, data);

        if (requestSequence === this.requestSequence) {
            this.applyResponse(response);
        }
    }

    async editTag(id, data) {
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedPut(
            `/tags/${ id }`, data);

        if (requestSequence === this.requestSequence) {
            this.applyResponse(response);
        }
    }

    async deleteTag(id) {
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedDelete(
            `/tags/${ id }`);

        if (requestSequence === this.requestSequence) {
            this.applyResponse(response);
        }
    }

    applyResponse(response) {
        if (!response || !response.data) {
            return;
        }
        const data = response.data.data_o;
        if (Array.isArray(data) || data === null) {
            this.tags = data || [];
        }
    }

    clear() {
        this.requestSequence += 1;
        this.tags = [];
    }
}

const tagsStore = new TagsStore();
registerAccountStateReset(() => tagsStore.clear());

export default tagsStore;
